import store from "@/store"
import { APPLICATION_TEMPLATE_GET, APPLICATION_GET } from "@/store/types"

export default {
  path: "/apply",
  name: "apply_base",
  component: () => import("@/views/apply/ApplyBase.vue"),
  beforeEnter: async (to, _, next) => {
    if (to.name === "apply_form") {
      if ((to.params.slug || to.meta.slug) && !store.getters.getCurrentApplicationTemplate) {
        const slug = to.params.slug || to.meta.slug

        try {
          await store.dispatch(APPLICATION_TEMPLATE_GET, { slug })
        } catch {
          next({ name: 'apply_not_found' })
          return false
        }

        if (
          !!process.env.VUE_APP_CLASSIC_BASE_URI &&
          !store.getters.getCurrentApplicationTemplate.landlord.edge_enabled
        ) {
          location.href = `${process.env.VUE_APP_CLASSIC_BASE_URI}/apply/${slug}${
            location.search ? location.search : ""
          }`
          return false
        }
      }
    }

    next()
  },
  children: [
    {
      path: "/404",
      name: "apply_not_found",
      component: () => import("@/views/error/NotFound.vue"),
    },
    {
      path: "sample",
      name: "apply_sample",
      component: () => import("@/views/apply/Apply.vue"),
      meta: {
        slug: "beta_default"
      }
    },
    {
      path: ":slug",
      name: "apply_form",
      component: () => import("@/views/apply/Apply.vue")
    },
    {
      path: ":slug/account",
      name: "apply_create_account",
      component: () => import("@/views/apply/CreateAccount.vue")
    },
    {
      path: ":id/edit",
      name: "apply_edit",
      component: () => import("@/views/apply/Apply.vue"),
      meta: {
        requireAuth: true
      }
    },
    {
      path: ":id/verify",
      name: "apply_verify",
      component: () => import("@/views/apply/Verify.vue"),
      beforeEnter: async (to, _, next) => {
        const { id } = to.params

        if (!store.getters.getCurrentApplication) {
          await store.dispatch(APPLICATION_GET, { id })
        }

        if (!store.getters.getCurrentApplication.need_applicant_experian_authtoken) {
          if (store.getters.getCurrentApplication.need_applicant_finicity_bank_connection) {
            next({
              name: "apply_verify_income",
              params: { id }
            })
            return
          } else {
            next({
              name: "apply_pay",
              params: { id }
            })
            return
          }
        }
        next()
      },
      meta: {
        requireAuth: true
      },
      children: [
        {
          path: "disclaimer",
          name: "apply_verify_disclaimer",
          component: () => import("@/views/dashboard/verify/Disclaimer.vue")
        },
        {
          path: "personal_info",
          name: "apply_verify_personal_info",
          component: () => import("@/views/dashboard/verify/PersonalInfo.vue")
        },
        {
          path: "questions",
          name: "apply_verify_questions",
          component: () => import("@/views/dashboard/verify/Questions.vue")
        },
        {
          path: "success",
          name: "apply_verify_success",
          component: () => import("@/views/dashboard/verify/Success.vue")
        },
        {
          path: "failure",
          name: "apply_verify_failure",
          component: () => import("@/views/dashboard/verify/Failure.vue")
        }
      ]
    },
    {
      path: ":id/verify/income",
      name: "apply_verify_income",
      component: () => import("@/views/apply/Income.vue"),
      meta: {
        requireAuth: true
      }
    },
    {
      path: ":id/pay",
      name: "apply_pay",
      component: () => import("@/views/apply/Pay.vue"),
      meta: {
        requireAuth: true
      }
    },
    {
      path: ":id/optin",
      name: "apply_affiliate_optin",
      component: () => import("@/views/apply/AffiliateOptIn.vue"),
      meta: {
        requireAuth: true
      }
    },
    {
      path: ":id/complete",
      name: "apply_complete",
      component: () => import("@/views/apply/Complete.vue"),
      meta: {
        requireAuth: true
      }
    }
  ],
}
